import React from 'react';
import PropTypes from 'prop-types';
import BriefcaseAccountOutlineIcon from 'mdi-react/BriefcaseAccountOutlineIcon';
import SwapHorizontalIcon from 'mdi-react/SwapHorizontalIcon';
import AccountArrowRightOutlineIcon from 'mdi-react/AccountArrowRightOutlineIcon';
import CalendarAccountOutlineIcon from 'mdi-react/CalendarAccountOutlineIcon';
import PodiumIcon from 'mdi-react/PodiumIcon';
import ChartLineIcon from 'mdi-react/ChartLineIcon';
import FormatListBulletedIcon from 'mdi-react/FormatListBulletedIcon';
import AccountGroupOutlineIcon from 'mdi-react/AccountGroupOutlineIcon';
import ClipboardTextOutlineIcon from 'mdi-react/ClipboardTextOutlineIcon';
import t, { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';
import exampleCurrency from '../../user_tiers/components/exampleCurrency';

/**
 * Deals in two steps: the partners' employees register what they do with
 * each other in the app (bought, sold, a reference or a meeting), then the
 * club follows the business the partner network creates here.
 */
const DealsShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  const currency = exampleCurrency(useConfig());
  return (
    <FeatureShowcase
      storageKey="dealsShowcaseHidden"
      icon={BriefcaseAccountOutlineIcon}
      title={s('dealsInfoTitle')}
      subtitle={s('dealsShowcaseSubtitle')}
      showLabel={s('dealsShowcaseShow')}
      uses={[
        {
          key: 'register',
          step: s('showcaseStep', { step: 1 }),
          icon: BriefcaseAccountOutlineIcon,
          label: s('dealsRegisterLabel'),
          text: s('dealsRegisterText'),
          cards: [
            {
              key: 'trade',
              icon: SwapHorizontalIcon,
              title: s('dealsCardTrade'),
              text: s('dealsCardTradeText', { currency }),
            },
            {
              key: 'reference',
              icon: AccountArrowRightOutlineIcon,
              title: s('dealsCardReference'),
              text: s('dealsCardReferenceText'),
              badges: [t('Deals.hot'), t('Deals.cold')],
            },
            {
              key: 'meeting',
              icon: CalendarAccountOutlineIcon,
              title: s('dealsCardMeeting'),
              text: s('dealsCardMeetingText'),
            },
            {
              key: 'lead',
              icon: PodiumIcon,
              title: s('dealsCardLead'),
              text: s('dealsCardLeadText'),
            },
          ],
        },
        {
          key: 'follow',
          step: s('showcaseStep', { step: 2 }),
          icon: ChartLineIcon,
          label: s('dealsFollowLabel'),
          text: s('dealsFollowText'),
          items: [
            { key: 'value', icon: ChartLineIcon, label: s('dealsItemValue') },
            {
              key: 'top',
              icon: PodiumIcon,
              label: s('dealsItemTop'),
            },
            {
              key: 'ranking',
              icon: AccountGroupOutlineIcon,
              label: s('dealsItemRanking'),
            },
            {
              key: 'log',
              icon: ClipboardTextOutlineIcon,
              label: s('dealsItemLog'),
            },
            {
              key: 'periods',
              icon: FormatListBulletedIcon,
              label: s('dealsItemPeriods'),
            },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

DealsShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

DealsShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default DealsShowcase;
